import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Autocomplete,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { CmpDatePicker } from "../../Component/Common/ToolBox/ToolBox";
import { useSelector } from "react-redux";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  ReportRemoveSequenceChar,
  ReportTitle,
  ReportUrl,
} from "../../Utility/Utilitys";
import moment from "moment";
import {
  WMS_PO_REVERSE_VARIANCE_POST,
  WMS_PO_VARIANCE_GETROW,
  WMS_PO_VARIANCE_POST,
} from "./WmsPoAction";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 500,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

// const initialRows = [
//   {
//     id: 1,
//     sheetId: "4000100001",
//     date: "2019-07-01",
//     refNo: "4000100001",
//     location: "DISTRIBUTION",
//     status: "POST",
//     user: "SUNIL RAJ",
//     count: "POST",
//   },
//   {
//     id: 2,
//     sheetId: "400011786",
//     date: "2025-01-01",
//     refNo: "400011786",
//     location: "DISTRIBUTION",
//     status: "POST",
//     user: "IMTHIYAZ",
//     count: "POST",
//   },
// ];

export default function WmsPoGenerateVaraiance() {
  const LocWithRights = useSelector((state) => state.SliceGRNLocation.value);
  const [filterState, setFilterState] = useState({
    sheetNo: "",
    fromDate: new Date(),
    toDate: new Date(),
    dcLocation: LocWithRights[0]?.UID,
    status: "Pending",
  });
  const [rows, setRows] = useState([]);
  const [errors, setErrors] = useState({});
  const [sWebReportModal, setWebReportModal] = React.useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = React.useState("");

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const fPrint = async (sheetId, type) => {
    setWebReportModal(true);
    if (sheetId !== "") {
      let webReport = vRdxDBKernObj.WEB_REPORT_BASE_URL;
      let urlPrint = webReport?.Val;
      let sCurrentReport = "";
      let sReportTitle = "";
      let ReportTitleObj = {
        Sheet: sheetId,
      };
      // Remove the trailing "&" character
      sReportTitle = ReportTitle(ReportTitleObj);
      let ReportUrlObj = {
        prntyp: type,
        Sheet: sheetId,
      };
      sCurrentReport = ReportUrl(ReportUrlObj);
      sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);
      console.log(
        "sCurrentReport",
        urlPrint + "WMS/POPhysicalStockVariance?" + sCurrentReport
      );
      setWebReportUrlModal(
        urlPrint + "WMS/POPhysicalStockVariance?" + sCurrentReport
      );
      setWebReportModal(true);
    } else {
      fAlertToast("FAILED", "Sheet Id not found");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilterState((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: !value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!filterState.fromDate) newErrors.fromDate = "FromDate is required";
    if (!filterState.toDate) newErrors.toDate = "ToDate is required";
    if (!filterState.dcLocation)
      newErrors.dcLocation = "DC Location is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLoad = async () => {
    if (!validate()) return;
    let FinalObj = fcheck_null_undefine_replace_empty({
      Type: filterState.status,
      SheetId: filterState.sheetNo,
      FromDate: moment(filterState.fromDate).format("MM/DD/YYYY"),
      ToDate: moment(filterState.toDate).format("MM/DD/YYYY"),
      Location: filterState.dcLocation,
    });
    const res = await WMS_PO_VARIANCE_GETROW(FinalObj);
    if (res?.status === 200) {
      setRows(res?.data?.ResultSet);
    }
  };

  const handleClear = () => {
    const defaultState = {
      sheetNo: "",
      fromDate: new Date(),
      toDate: new Date(),
      dcLocation: "",
      status: "Pending",
    };
    setFilterState(defaultState);
    setErrors({});
  };

  const handleVarianceClick = async (sheetId) => {
    const res = await WMS_PO_VARIANCE_POST({ SheetId: sheetId || "" });
    if (res?.status === 200) {
      fAlertToast("SUCCESS", "Variance posted successfully");
      handleLoad();
    }
  };
  const handleReverseVarianceClick = async (sheetId) => {
    const res = await WMS_PO_REVERSE_VARIANCE_POST({ SheetId: sheetId || "" });
    if (res?.status === 200) {
      fAlertToast("SUCCESS", "Reverse Variance successfully");
      handleLoad();
    }
  };
  const columns = [
    {
      field: "variance",
      headerName: "Variance",
      renderCell: (params) => (
        <Button
          variant="contained"
          size={"small"}
          disabled={params.row.A_Vari_Status === "POST"}
          onClick={() => handleVarianceClick(params.row.A_SheetId)}
        >
          Generate Variance
        </Button>
      ),
      width: 150,
      sortable: false,
      filterable: false,
    },
    {
      field: "reverseVariance",
      headerName: "Reverse Variance",
      renderCell: (params) => (
        <Button
          variant="contained"
          size={"small"}
          disabled={params.row.A_Vari_Status === "ENTER"}
          onClick={() => handleReverseVarianceClick(params.row.A_SheetId)}
        >
          Reverse Variance
        </Button>
      ),
      width: 150,
      sortable: false,
      filterable: false,
    },
    {
      field: "wmsVsPhy",
      headerName: "WMS vs PHY",
      renderCell: (params) => (
        <Button
          variant="contained"
          size={"small"}
          onClick={() => fPrint(params.row.A_SheetId, "WMSVSPHY")}
        >
          WMS vs PHY
        </Button>
      ),
      width: 100,
      sortable: false,
      filterable: false,
    },
    {
      field: "rpVsPhy",
      headerName: "RP vs PHY",
      renderCell: (params) => (
        <Button
          variant="contained"
          size={"small"}
          onClick={() => fPrint(params.row.A_SheetId, "RPVSPHY")}
        >
          RP vs PHY
        </Button>
      ),
      width: 100,
      sortable: false,
      filterable: false,
    },
    { field: "A_SheetId", headerName: "Sheet ID", width: 95 },
    {
      field: "A_Date",
      headerName: "Date",
      width: 90,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref No", width: 95 },
    { field: "A_Vari_Status", headerName: "Variance Status", width: 110 },
    { field: "A_Status", headerName: "Status", width: 80 },
    { field: "UserName", headerName: "User", width: 150 },
    // { field: "Name1", headerName: "Name", width: 150 },
    // { field: "A_TransSrNo", headerName: "Trans Sr.No", width: 100 },
  ];

  return (
    <>
      <Box sx={{ p: 1.5 }}>
        <Typography variant="h6" gutterBottom>
          PO Physical Stock - Variance
        </Typography>
        <Grid container spacing={{ xs: 0.8, sm: 1.4 }} alignItems="center">
          <Grid item xs={6} sm={2} md={2}>
            <TextField
              label="Sheet No"
              name="sheetNo"
              fullWidth
              size={"small"}
              type="number"
              autoComplete="off"
              error={!!errors.sheetNo}
              helperText={errors.sheetNo}
              value={filterState.sheetNo}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={6} sm={2} md={2}>
            <CmpDatePicker
              xLabelText={"From Date"}
              xValue={filterState.fromDate}
              xOnChange={(newValue) =>
                setFilterState((obj) => ({
                  ...obj,
                  fromDate: newValue.$d,
                }))
              }
              size={"small"}
              xFullWidth={true}
              xError={!!errors.fromDate}
              xErrorMessage={errors.fromDate}
            />
          </Grid>
          <Grid item xs={6} sm={2} md={2}>
            <CmpDatePicker
              xLabelText={"To Date"}
              xValue={filterState.toDate}
              xOnChange={(newValue) =>
                setFilterState((obj) => ({
                  ...obj,
                  toDate: newValue.$d,
                }))
              }
              size={"small"}
              xFullWidth={true}
              xError={!!errors.toDate}
              xErrorMessage={errors.toDate}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <Autocomplete
              freeSolo
              size="small"
              id="dc-location"
              disableClearable
              options={LocWithRights} // Use full objects
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.Name1
              } // Support free text input
              value={
                LocWithRights?.find(
                  (loc) => loc.UID === filterState.dcLocation
                ) || null
              }
              onChange={(event, newValue) => {
                if (typeof newValue === "string") {
                  setFilterState((prev) => ({
                    ...prev,
                    dcLocation: newValue, // Store typed value
                  }));
                } else if (newValue) {
                  setFilterState((prev) => ({
                    ...prev,
                    dcLocation: newValue.UID, // Store UID when selecting from dropdown
                  }));
                }
              }}
              renderInput={(params) => (
                <TextField
                  size={"small"}
                  label="DC Location"
                  {...params}
                  type="search"
                  error={!!errors.dcLocation}
                  helperText={errors.dcLocation}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={5} md={3} lg={2}>
            <RadioGroup
              row
              name="status"
              value={filterState.status}
              onChange={handleInputChange}
            >
              <FormControlLabel
                value="Pending"
                control={<Radio />}
                label="Pending"
              />
              <FormControlLabel
                value="History"
                control={<Radio />}
                label="History"
              />
            </RadioGroup>
          </Grid>
          <Grid item xs={3} sm={1.5} md={1}>
            <Button
              fullWidth
              variant="contained"
              size="small"
              onClick={handleLoad}
            >
              Load
            </Button>
          </Grid>
          <Grid item xs={3} sm={1.5} md={1}>
            <Button
              fullWidth
              variant="contained"
              size="small"
              color="error"
              onClick={handleClear}
            >
              Clear
            </Button>
          </Grid>
        </Grid>
        <Box
          sx={{
            mt: 2,
            height: {
              xs: "62.5vh",
              sm: "61.5vh",
              md: "66vh",
              lg: "70vh",
              xl: "74vh",
            },
          }}
        >
          <DataGrid
            rows={rows ?? []}
            columns={columns}
            components={{
              Toolbar: GridToolbar,
            }}
            headerHeight={40}
            rowHeight={30}
            getRowId={(row) => row.A_SheetId}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
              borderColor: "primary.light",
            }}
            // autoHeight
            disableRowSelectionOnClick
          />
        </Box>
      </Box>
      <GCWebReport
        xfCloseWebReportModal={() => setWebReportModal(false)}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </>
  );
}
